import React, { Component } from "react";
import { Row, Col, Card, CardBody, Button, Label, Alert } from "reactstrap";
import Page from "components/Page";
import { Textarea } from "react-inputs-validation";
import Select from 'react-select';
import makeAnimated from 'react-select/lib/animated';
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { urlListarCiudadesHogar } from '../../constants/urls'
import { FetchPost } from '../../redux/actions/api'
import { ambienteAplicacion } from "../../constants/urls";
import { FetchDataCarritoHogar, LimpiarCarritoHogar, setProductoActualCotizadoHogar, isDuplicateHogar/* , setHogarIsDuplicate */ } from "../../redux/actions/ACarritoProductos";
import LoadingScreen from "react-loading-screen";
import logo from "assets/img/logo/logo_aig_login-2.png";

import '../../styles/estilos.css'
import { ErrorMsgConstants } from "../../constants";
import { obtenerDatosHogar } from "../../utils/validaciones";

class CotizacionUbicacionPaso1 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasProvinciaError: true,
      hasCiudadError: true,
      validate: false,
      provinciaSelected: "",
      datosHogar: obtenerDatosHogar(null),
      ciudadSelected: "",
      arrayProvincias: this.props.catalogo.setProvinciasHogar.provincias2 ? this.props.catalogo.setProvinciasHogar.provincias2 : [],
      arrayCiudades: [],
      direccionSelected: "",
      cargandoCiudades: false,
      agregarItem: false,
    };
  }

  componentDidMount() {
    const queryParams = new URLSearchParams(this.props.location.search);
    const accion = queryParams.get('accion');
    const codEdicion = queryParams.get('codEdicion');
   
    let producto = null
    let seguro = this.props.carrito.setCarritoHogar.carDescripcionSeguro;

    switch (seguro) {
      case 'HOGAR AIG':
        producto = 'hogar-aig'
        break;

      case 'HOGAR ADVANCE':
        producto = 'advance'
        break;

      default:
        break;
    }

    this.setState({ datosHogar: obtenerDatosHogar(producto) })


    if (accion === "" || accion === null) {
      this.precargarDatosBotonBack(codEdicion);
    }
    else {
      this.setState({ agregarItem: true })
    }

    console.log('descripcion', this.props.carrito.setCarritoHogar)
  }

  async precargarDatosBotonBack(codEdicion) {
    if (this.props.carrito.setCarritoHogar && this.props.carrito.setCarritoHogar.carProductos) {
      let codProdActualBuscar = this.props.carrito.setCarritoHogar.carCodigoProductoActual
      if (codEdicion !== undefined && codEdicion !== "" && codEdicion !== null) {
        codProdActualBuscar = codEdicion;
      }
      //Obtener Producto actual
      let ObtenerProductoActual = this.props.carrito.setCarritoHogar.carProductos.filter((item) =>
        item.codigo === codProdActualBuscar
      )
      ObtenerProductoActual = ObtenerProductoActual[0];
      if (ObtenerProductoActual && ObtenerProductoActual !== '') {
        await this.onChangeProvincia(ObtenerProductoActual.datosUbicacion.provincia.value);
        this.setState({
          provinciaSelected: ObtenerProductoActual.datosUbicacion.provincia,
          ciudadSelected: ObtenerProductoActual.datosUbicacion.ciudad,
          direccionSelected: ObtenerProductoActual.datosUbicacion.direccion ? ObtenerProductoActual.datosUbicacion.direccion : "",
          hasProvinciaError: false,
          hasCiudadError: false
        })
      }
    }
  }

  onChangeProvincia = async (provincia) => {
    let { cargandoCiudades } = this.state;
    this.setState({ cargandoCiudades: true })
    let resp = await FetchPost({
      url: urlListarCiudadesHogar, param: {
        empresa: "AIGMETROPOLITANA",
        codProvincia: provincia,
        ramo: "hogar"
      }
    })
    const { transaccion, ciudades } = resp
    if (transaccion) {
      this.setState({ arrayCiudades: ciudades })
    }
    this.setState({ cargandoCiudades: false })
  }
  toggleValidating(validate) {
    this.setState({ validate });
  }

  onValidateform = async () => {
    let { provinciaSelected, ciudadSelected, direccionSelected, agregarItem } = this.state;
    this.toggleValidating(true);
    if (provinciaSelected !== "" && ciudadSelected != "" && direccionSelected !== "") {
      let codigoProdActual = "";
      if (this.props.carrito.setCarritoHogar.carProductos !== null && this.props.carrito.setCarritoHogar.carProductos !== undefined && agregarItem === false) {
        // Obtener el producto actual
        let ObtenerProductoActual = this.props.carrito.setCarritoHogar.carProductos.filter((item) =>
          item.codigo === this.props.carrito.setCarritoHogar.carCodigoProductoActual
        )
        ObtenerProductoActual = ObtenerProductoActual[0];
        codigoProdActual = ObtenerProductoActual.codigo;
        //verificar si es el producto actual o es una edidcion        
        const queryParams = new URLSearchParams(this.props.location.search);
        const codEdicion = queryParams.get('codEdicion');
        if (codEdicion !== "" && codEdicion !== null) {
          codigoProdActual = codEdicion
        }
      }
      //Datos a enviar al carrito
      const datosCarrito = {
        empresa: "AIGMETROPOLITANA",
        provincia: provinciaSelected,
        ciudad: ciudadSelected,
        direccion: direccionSelected,
        mongoCarrito: this.props.carrito.setCarritoHogar.mongoCarrito,
        pasoCarrito: "inicioUbicacion",
        codigo: codigoProdActual
      }
      const checkDuplicidadHogar = {
        empresa: "AIGMETROPOLITANA",
        plataforma: 'WEB',
        identificacion: this.props.carrito.setCarritoHogar.carDatosContratante.cliIdentificacion,
        provincia: provinciaSelected.value,
        ciudad: ciudadSelected.value,
        direccion: direccionSelected,
      };
      console.log('carrito es ', this.props.carrito);
      console.log('check duplicidad ', checkDuplicidadHogar);
      // guardar el carrito y validar si es una poliza duplicada (el backend determina eso)
      await this.props.setCarrito(datosCarrito);
      await this.props.checkIsDuplicate({ type: 'hogar', postObj: checkDuplicidadHogar });

      // en caso de no haber error y no ser duplicado, continuar al siguiente paso
      if (this.props.carrito.carritoHogarError === false && this.props.duplicity.duplicidadPolizaError === false && this.props.duplicity.isDuplicatePoliza === false) {
        const queryParams = new URLSearchParams(this.props.location.search);
        const codEdicion = queryParams.get('codEdicion');
        if (codEdicion === '' || codEdicion === null) {
          //Redireccionar paso 2
          this.props.history.push(
            {
              pathname: "/cotizacion-hogar-paso2",
              search: this.state.datosHogar.codigo != null
                ? "?producto=" + this.state.datosHogar.codigo
                : "",
            }
          );
        }
        else {
          //Redireccionar paso 2
          this.props.history.push({ pathname: "/cotizacion-hogar-paso2", search: `codEdicion=${codEdicion}${this.state.datosHogar.codigo != null ? "&producto=" + this.state.datosHogar.codigo : ""}` });
        }
      }
    }
  }

  onRegresar = async () => {
    let { agregarItem } = this.state;
    if (agregarItem && agregarItem === true || (this.props.carrito.setCarritoHogar.carProductos && this.props.carrito.setCarritoHogar.carProductos.length > 1)) {
      //Redireccionar al resumen 
      this.props.history.push({
        pathname: "/cotizacion-hogar-paso5",
        search: `?idCarrito=${this.props.carrito.setCarritoHogar.mongoCarrito}${this.state.datosHogar.codigo != null ? "&producto=" + this.state.datosHogar.codigo : ""}`
      });
    }
    else {
      //Redireccionar a datos del contratante
      this.props.history.push({
        pathname: "/cotizacion-hogar-datospersonales",
        search: `?back=true${this.state.datosHogar.codigo != null ? "&producto=" + this.state.datosHogar.codigo : ""}`
      });
    }
  }


  render() {
    let { provinciaSelected, hasProvinciaError, hasCiudadError, ciudadSelected, arrayProvincias, arrayCiudades, direccionSelected, validate, cargandoCiudades } = this.state;
    let cargandoCarritoHogar = this.props.carrito.carritoHogarloading ? this.props.carrito.carritoHogarloading : false;
    return (
      <LoadingScreen
        loading={this.props.catalogo.listarProvinciasHogarloading || cargandoCarritoHogar || this.props.duplicity.duplicidadPolizaLoading || cargandoCiudades}
        bgColor="#f1f1f1"
        spinnerColor="#001871"
        textColor="#676767"
        logoSrc={logo}
        text="Cargando..."
      >
        <Page title={this.state.datosHogar.titulo} breadcrumbs={[{ name: this.state.datosHogar.titulo, active: true }]}>

          <div className="container-step">
            <div className="wrapper-step">
              <div className="arrow-steps clearfix-step">
                <div className="step current"> {` 1. Cotización `} </div>
                <div className="step"> {` 2. Resumen `} </div>
                <div className="step"> {` 3. Confirmación `} </div>
                <div class="step"> {` 4. Forma de Pago `} </div>
                <div class="step"> {` 5. Formulario de Vinculación `} </div>
                <div class="step"> {` 6. Emisión `} </div>
              </div>
            </div>
          </div>
          <Row>
            <Col md={12} className="mb-3">
              <Card className="flex-row ">
                <CardBody>
                  <h4 style={{ fontWeight: "bold" }} className='mb-5'>Ubicación del Bien Asegurado</h4>
                  <Row>
                    <Col lg={2}></Col>
                    <Col lg={8} md={12} sm={12} xs={12}>
                      <Row>
                        <Col lg={3} md={4} sm={12} xs={12}><h5><Label for="exampleSelect" className="bold-font-label" >Provincia</Label></h5></Col>
                        <Col lg={9} md={8} sm={12} xs={12}>
                          <Select
                            value={provinciaSelected}
                            components={makeAnimated()}
                            onChange={(provincia, e) => {
                              this.setState({
                                provinciaSelected: provincia,
                                hasProvinciaError: false,
                                ciudadSelected: "",
                                hasCiudadError: true
                              });
                              this.onChangeProvincia(provincia.value.toString())
                            }}
                            options={arrayProvincias}
                            isSearchable={true}
                            placeholder={"Seleccione una provincia"}
                            isMulti={false}
                          />
                          {hasProvinciaError &&
                            <span style={{ color: "red", fontSize: "1rem" }}>Por favor seleccione una provincia</span>
                          }
                        </Col>
                      </Row>
                    </Col>
                    <Col lg={2}></Col>
                  </Row>

                  <Row>
                    <Col lg={2}></Col>
                    <Col lg={8} md={12} sm={12} xs={12}>
                      <Row>
                        <Col lg={3} md={4} sm={12} xs={12}><h5><Label for="exampleSelect" className="bold-font-label" >Ciudad</Label></h5></Col>
                        <Col lg={9} md={8} sm={12} xs={12}>
                          <Select
                            value={ciudadSelected}
                            components={makeAnimated()}
                            onChange={(ciudad, e) => {
                              this.setState({
                                ciudadSelected: ciudad,
                                hasCiudadError: false
                              });
                            }}
                            options={arrayCiudades}
                            isSearchable={true}
                            placeholder={"Seleccione una ciudad"}
                            isMulti={false}
                          />

                          {hasCiudadError &&
                            <span style={{ color: "red", fontSize: "1rem" }}>Por favor seleccione una ciudad</span>
                          }
                        </Col>
                      </Row>
                    </Col>
                    <Col lg={2}></Col>
                  </Row>

                  <Row>
                    <Col lg={2}></Col>
                    <Col lg={8} md={12} sm={12} xs={12}>
                      <Row>
                        <Col lg={3} md={4} sm={12} xs={12}><h5><Label for="exampleSelect" className="bold-font-label" >Dirección del Bien Asegurado</Label></h5></Col>
                        <Col lg={9} md={8} sm={12} xs={12}>
                          <Textarea
                            //tabIndex="1" // Optional.[String or Number].Default: none.
                            id="direccion" // Optional.[String].Default: "".  Textarea ID.
                            name="direcion" // Optional.[String].Default: "". Input name.
                            value={direccionSelected} // Optional.[String].Default: "".
                            placeholder="Ingrese una Dirección" // Optional.[String].Default: "".
                            onChange={(direccion, e) => {
                              this.setState({ direccionSelected: direccion.toUpperCase() });
                            }} // Required.[Func].Default: () => {}. Will return the value.
                            onBlur={(e) => { console.log(e) }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                            validate={validate}
                            validationCallback={res =>
                              //console.log(res)
                              this.setState({
                                validate: res,
                              })}
                            validationOption={{
                              name: 'Dirección', // Optional.[String].Default: "". To display in the Error message. i.e Please enter your {name}.
                              check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                              required: false, // Optional.[Bool].Default: true. To determin if it is a required field.
                              //msgOnError: "Debe ingresar una dirección." // Optional.[Bool].Default: true. To determin if it is a required field.
                              customFunc: res => {
                                //Optional.[Func].Default: none. Custom function. Returns true or err message
                                res = direccionSelected
                                if (res === "" || res === null || res === undefined) {
                                  this.setState({ direccionSelected: "" });
                                  return "Debe ingresar una dirección.";
                                }
                                return true;
                              }
                            }}
                          />
                        </Col>
                      </Row>
                    </Col>
                    <Col lg={2}></Col>
                  </Row>
                  <Row>
                    <Col lg={12} md={12} sm={12} xs={12}>
                      <div style={{ textAlign: "center" }}>
                        <Button className={"button-white"} onClick={this.onRegresar}>
                          <i className="fa fa-chevron-circle-left" aria-hidden="true" />{" "}
                          REGRESAR
                        </Button>
                        {"   "}
                        <Button onClick={this.onValidateform} className="btn btn-primary" >
                          <i className="fa fa-chevron-circle-right" aria-hidden="true" />{` CONTINUAR`}
                        </Button>
                        {/* Mensaje de error*/}
                        <div style={{ marginTop: '2rem' }}>
                          {/* Validacion de duplicidad */}
                          {console.log('test dup msg ', this.props.duplicity, this.props.carrito)}
                          {this.props.duplicity.isDuplicatePoliza
                            ?
                            <Alert color="danger" isOpen={this.state.visibleAlert}>
                              <center><p>{ErrorMsgConstants.duplicidad}</p></center>
                            </Alert>
                            :
                            null
                          }

                          {/* Mensajes de errores al usuario */}
                          {this.props.carrito.carritoHogarError &&
                            <Alert color="danger">
                              <center><p>Ha ocurrido un inconveniente al guardar la información. Por favor intente nuevamente.</p></center>
                            </Alert>
                          }
                          {this.props.duplicity.duplicidadPolizaError &&
                            <Alert color="danger">
                              <center><p>{ErrorMsgConstants.errorServicioDuplicidad}</p></center>
                            </Alert>
                          }
                        </div>
                      </div>
                    </Col>
                  </Row>

                </CardBody>
              </Card>
            </Col>
          </Row>
        </Page>
      </LoadingScreen>

    );
  }
};

const mapStateToProps = state => ({
  catalogo: state.catalogosHogar,
  datosAsesor: state.datosUsuarios.dataUsuario,
  carrito: state.datosCarritoHogar,
  duplicity: state.datosDuplicidadPolizas,
});

const mapDispatchToProps = dispatch => {
  return {
    setCarrito: (datosCarrito) => dispatch(FetchDataCarritoHogar(datosCarrito)),
    limpiarCarrito: () => dispatch(LimpiarCarritoHogar()),
    setProductoActual: (param) => dispatch(setProductoActualCotizadoHogar(param)),
    checkIsDuplicate: (datosCheckDuplicity) => dispatch(isDuplicateHogar(datosCheckDuplicity)),

  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(CotizacionUbicacionPaso1)
);

